import React from "react";
import "../styles/MyWork.scss";
import { ProjectCard } from "./ProjectCard";
import { data } from "../assets/data/projectData";

export function MyWork() {
  return (
    <>
      <section id="work" className="work">
        <h3>MY WORK</h3>
        <div className="native-project-container">
          <h4>Native Solution</h4>
          <div className="native-display">
            <div className="project-heading">
              <h5>How To</h5>
              <div className="line-decoration"></div>
            </div>
            <div className="phone-container">
              <div className="phone">
                <img
                  src={require("../assets/images/main.svg")}
                  alt="mobile phone display"
                />
              </div>
              <div className="croppedgif">
                <img
                  src={require("../assets/images/croppedphone.gif")}
                  alt="Mobile phone animation"
                />
              </div>
            </div>
            <div className="project-description">
              <p>
                Need an all in one solution? I can build native applications for
                iOS/Android as well as dynamic web applications.
              </p>
              <h6>Tools</h6>
              <ul>
                <li>React Native</li>
                <li>XCode</li>
                <li>Android Studio</li>
              </ul>
              <div className="links">
                <a
                  href="https://github.com/cladams0203/HowToApp/tree/master/howToNative"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Github
                </a>
                {/* <a href="#">Explore</a> */}
              </div>
            </div>
          </div>
        </div>
        <h4>Web Projects</h4>
        <div className="web-project-container">
          {data.map((item, index) => {
            return <ProjectCard project={item} key={index} />;
          })}
        </div>
      </section>
    </>
  );
}
